export const SESSION_TIMEOUT = 'Registraton/SESSION_TIMEOUT'

export const INIT = 'Registration/INIT'
export const FETCH_DATA_ERROR = 'Registration/FETCH_DATA_ERROR'
export const FETCH_DATA_SUCCESS = 'Registration/FETCH_DATA_SUCCESS'

export const ON_WELCOME_NEXT = 'Registration/ON_WELCOME_NEXT'
export const ON_BACK = 'Registration/ON_BACK'
export const ON_BACK_TWO_STEPS = 'Registration/ON_BACK_TWO_STEPS'
export const ON_NEXT = 'Registration/ON_NEXT'
export const ON_BACK_AUTHENTICATORS = 'Registration/ON_BACK_AUTHENTICATORS'

export const ON_FINISH = 'Registration/ON_FINISH'

export const INIT_SEND_CHALLENGE = 'Registration/INIT_SEND_CHALLENGE'
export const INIT_SEND_CHALLENGE_SUCCESS = 'Registration/INIT_SEND_CHALLENGE_SUCCESS'
export const INIT_SEND_CHALLENGE_ERROR = 'Registration/INIT_SEND_CHALLENGE_ERROR'

export const RESEND_CODE = 'Registration/RESEND_CODE'
export const RESEND_CODE_SUCCESS = 'Registration/RESEND_CODE_SUCCESS'
export const RESEND_CODE_ERROR = 'Registration/RESEND_CODE_ERROR'


export const SUBMIT_VERIFICATION = 'Registration/SUBMIT_VERIFICATION'
export const SUBMIT_VERIFICATION_SUCCESS = 'Registration/SUBMIT_VERIFICATION_SUCCESS'
export const SUBMIT_VERIFICATION_ERROR = 'Registration/SUBMIT_VERIFICATION_ERROR'

export const SUBMIT_PASSWORD = 'Registration/SUBMIT_PASSWORD'
export const SUBMIT_PASSWORD_SUCCESS = 'Registration/SUBMIT_PASSWORD_SUCCESS'
export const SUBMIT_PASSWORD_ERROR = 'Registration/SUBMIT_PASSWORD_ERROR'

export const INIT_USER_APPS = 'Registration/INIT_USER_APPS'
export const INIT_USER_APPS_SUCCESS = 'Registration/INIT_USER_APPS_SUCCESS'
export const INIT_USER_APPS_ERROR = 'Registration/INIT_USER_APPS_ERROR'

export const INIT_AUTHENTICATORS = 'Registration/INIT_AUTHENTICATORS'
export const INIT_AUTHENTICATORS_SUCCESS = 'Registration/INIT_AUTHENTICATORS_SUCCESS'
export const INIT_AUTHENTICATORS_ERROR = 'Registration/INIT_AUTHENTICATORS_ERROR'

export const ENROLL_MFA = 'Registration/ENROLL_MFA'
export const ENROLL_MFA_SUCCESS = 'Registration/ENROLL_MFA_SUCCESS'
export const ENROLL_MFA_ERROR = 'Registration/ENROLL_MFA_ERROR'

export const INIT_ENROLL_FACTOR = 'Registration/INIT_ENROLL_FACTOR'
export const INIT_ENROLL_FACTOR_SUCCESS = 'Registration/INIT_ENROLL_FACTOR_SUCCESS'
export const INIT_ENROLL_FACTOR_ERROR = 'Registration/INIT_ENROLL_FACTOR_ERROR'

export const SET_AUTHENTICATOR = 'Registration/SET_AUTHENTICATOR'
export const SET_DEVICE_TYPE = 'Registration/SET_DEVICE_TYPE'

export const QR_CODE_NEXT = 'Registration/QR_CODE_NEXT'
export const QR_CODE_CANNOT_SCAN = 'Registration/QR_CODE_CANNOT_SCAN'
export const QR_CODE_CANNOT_SCAN_NEXT = 'Registration/QR_CODE_CANNOT_SCAN_NEXT'

export const VERIFY_AUTHENTICATOR_CODE = 'Registration/VERIFY_AUTHENTICATOR_CODE'
export const VERIFY_AUTHENTICATOR_CODE_SUCCESS = 'Registration/VERIFY_AUTHENTICATOR_CODE_SUCCESS'
export const AFTER_VERIFY_AUTHENTICATOR_CODE_SUCCESS = 'Registration/AFTER_VERIFY_AUTHENTICATOR_CODE_SUCCESS'
export const VERIFY_AUTHENTICATOR_CODE_ERROR = 'Registration/VERIFY_AUTHENTICATOR_CODE_ERROR'

export const GET_ACCOUNT_RECOVERY = 'Registration/GET_ACCOUNT_RECOVERY'
export const GET_ACCOUNT_RECOVERY_SUCCESS = 'Registration/GET_ACCOUNT_RECOVERY_SUCCESS'
export const GET_ACCOUNT_RECOVERY_ERROR = 'Registration/GET_ACCOUNT_RECOVERY_ERROR'

export const ACCOUNT_RECOVERY_SELECTION = 'Registration/ACCOUNT_RECOVERY_SELECTION'

export const SETUP_RECOVERY_PHONE = 'Registration/SETUP_RECOVERY_PHONE'
export const SETUP_RECOVERY_PHONE_SUCCESS = 'Registration/SETUP_RECOVERY_PHONE_SUCCESS'
export const SETUP_RECOVERY_PHONE_ERROR = 'Registration/SETUP_RECOVERY_PHONE_ERROR'

